import { useEffect } from 'react';
import * as L from 'leaflet';
import { useMap } from 'react-leaflet';
import { GeoSearchControl, GoogleProvider } from 'leaflet-geosearch';
import { geosearch as geosearchConfig } from '../../app/config';

// see https://github.com/smeijer/leaflet-geosearch#geosearchcontrol
const SearchBar = ({ position = 'topright' }) => {
  const provider = new GoogleProvider({ params: { key: process.env.REACT_APP_GOOGLE_GEOCODING_API_KEY } });

  const searchControl = new GeoSearchControl({
    provider,
    position,
    marker: {
      icon: L && L.Icon ? new L.Icon.Default() : undefined,
      draggable: false,
    },
    classNames: { form: 'primary-search-form' },
    ...geosearchConfig,
  });

  const map = useMap();

  useEffect(() => {
    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  }, []);

  return null;
};

export default SearchBar;
